<template lang="html">
  <div :class="['container container-custom']">
    <label
      :class="['label-custom', marginb, msDisabled ? 'cursor-default' : '']"
      class="ms-radio"
      tabindex="1"
      @keyup.enter="onEnter"
    >
      <!-- NVHIEU 18/12/2020 thêm disabled control -->
      <input
        v-bind="$attrs"
        :checked="isChecked"
        type="radio"
        class="ms-radio--input"
        :value="value"
        :name="msName"
        :disabled="msDisabled"
        v-on="listeners"
      >
      <div class="checkmark">
        <div :class="[isChecked ? 'mi-radio-button-check' : 'mi-radio-button-uncheck','m-t-l-5', setDisabled]" />
      </div>
      <span class="con-slot-label">
        <slot />
      </span>
    </label>
  </div>
</template>

<script>
import _color from '../color'
export default {
  name:'MsRadio',
  inheritAttrs:false,
  props:{
    msValue:{},
    value:{},
    msName:{
      default:'',
      type:String
    },
    marginb: {
      default:'m-b-0',
      type:String
    },
    msDisabled: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
    }
  },
  computed:{
    listeners(){
      return {
        ...this.$listeners,
        input: () => this.$emit('input', this.msValue),
        click: () => this.$emit('clicked', this.msValue)
      }
    },
    attrs(){
      let attrsx = JSON.parse(JSON.stringify(this.$attrs))
      return {
        attrsx
      }
    },
    // set class làm mờ radio
    setDisabled() {
      if (this.msDisabled) {
        return "disabled";
      } else {
        return "";
      }
    },
    isChecked(){
      return this.msValue == this.value
    },
  },
  methods:{
    onEnter(){
      this.msValue = !this.msValue;
      this.$emit('input', this.msValue);
      this.$emit('clicked', this.msValue)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/controls/msRadio.scss';
.disabled{
  opacity: 0.5 !important;
}
.ms-radio:active .checkmark{
  border-radius: 50%;
  background-color: var(--primary) !important;
}
.ms-radio:hover .checkmark{
  border-radius: 50%;
  background-color: #ebebeb !important;
}

.ms-radio:hover .mi-radio-button-check.checkmark{
  border-radius: 50%;
  background-color: var(--primary) !important;
}
.m-t-l-5{
  margin-left: 7px !important;
  margin-top: 5px !important;
}
.cursor-default {
  cursor: default !important;
}
.container-custom{
  cursor: default;
  .label-custom{
    display: inline-flex;
    cursor: pointer;
  }
}
</style>